 export class SubjectService {

public subject_service_id?: number;
public subject_id?: number;
public job_id?: number;
public subject_service_method_id?: number;
public fellow_occupants_name?: any;
public fellow_occupants_relationship?: any;
public fellow_occupants_sex?: any;
public authorised_employee_name?: any;
public authorised_employee_job_title?: any;
public authorised_employee_sex?: any;
public office_business_name?: any;
public exact_service_method?: any;
public created_by?: any;
public created_date?: any;
public date_service?: any;
public time_service?: any;
public who_service?: number;

public subject_service_outcome_id?: number;
public address_1?: string;
public address_2?: string;
public state?: string;
public suburb?: string;
public country?: string;
public postcode?: string;

public new_address?: string; // if set a new subject stage will be created in service attendence
public new_address_1?: string;
public new_address_2?: string;
public new_state?: string;
public new_suburb?: string;
public new_country?: string;
public new_postcode?: string;

public subject_location_status_id?: string;
public subject_location_status_found_id?: string;
public vehicles?: string;
public neighbours?: string;
public calling_card?: string;
public postal_mail?: string;
public phone_call?: string;
public attempts?: string;
public person_type?: string;
public person_spoken_with?: string;
public person_spoken_with_advised?: string;
public title?: string;
public first_name?: string;
public middle_name?: string;
public surname?: string;
public business_name?: string;
public new_business_name?: string;

public pre_subject_id?: number;
public service_number?: number;

subject_attempt_type_id?: number;
vehicles_notes?: string;
neighbours_notes?: string;
calling_card_notes?: string;
postal_mail_notes?: string;
attempts_notes?: string;
phone_call_notes?: string;

subject_name?: string;
subject_number?: string;
subject_service_method_name?: string;
fellow_occupants_relationship_name?: string;
exact_service_method_name?: string;
subject_service_outcome_name?: string;
who_service_name?: string;
subject_location_status_name?: string;
subject_location_status_found_name?: string;

address_full?: string; // all as one
new_address_full?: string;

file_number?: number;
reference_number?: number;
last_insert_id?: any;

send_communications?: any;
   brand_report_id?: any;
   brand_invoice_id?: any;


//  July 2022 Additial affidavit and service methods and types additions
subject_service_method_true_id?: number; // created as the API converts the real ID to a name when pulling in some functions/hard coded.
subject_service_outcome_true_id?: number; // created as the API converts the real ID to a name when pulling in some functions/hard coded.
// withness
witness_name?: string;
witness_business_name?: string;
witness_address_1?: string;
witness_address_2?: string;
witness_state?: string;
witness_postcode?: string;
witness_country?: string;
witness_suburb?: string;

person_in_charge_of_prison_name?: string;
person_in_charge_of_prison_occupation?: string;

subject_contact_email_id?: number;
email_address_served?: string; // 
director_name?: string; //
service_under_order?: string;

// subject_service_id?: number;
service_file_array?: any;
general_notes?: string;
email_contents?: string;
phone_number?: string;
subject_contact_number_id?: number;

is_count?: number;





// Drive By and occupancy.
property_images?: any; // array_name and holder
attach_file_array_name?: any; // set if passed
property_occupied?: string;

property_occupied_details?: string;
property_type_id?: number;
property_type_name?: string;
property_type_details?: string;
property_type_images?: any; // array_name and holder


property_forsale_or_lease_sign?: string;
property_sign_images?: any;
property_forsale_or_lease_sign_details?: string;

// property_sign_field_meta?: any[];
property_sign_field_meta?: any;

property_agent_name?: string;
property_agency_name?: string;
property_agency_contact_numbers?: string;


property_mail?: string;
property_mail_images: any;
property_mail_details?: string;

property_vehicles_sighted?: string;
property_vehicles_sighted_details?: string;
property_vehicles_images
property_v_make?: string;
property_v_model?: string;
property_v_plate?: string;
property_v_rego_state?: string;

property_pets?: string;
property_pets_details?: string;
property_pets_images?: any;


property_occupancy?: string;
property_occupancy_details?: string;
property_occupancy_images: any;

property_o_name?: string;
property_o_contact_numbers?: string;
property_o_lease_details?: string;
property_o_lease_date?: string;
property_o_landlord_contacts?: string;

property_condition?: string;
property_condition_images?: any;


public additional_subject: number;
public subject_array: any;

public time_service_local: any;
public date_service_local: any;
public service_local: any;
public service_local_offset: any;
public service_local_timezone: any;

time_service_text?: any;

public service_paragraph: any;
public service_paragraph_rendered: any;


public yes_manual_paragraph: any;
public manual_paragraph_rendered: any;
public service_paragraph_rendered_plain_text: any;

public ssot_id: number;

// Extra HTML Fields.
general_notes_HTML?: string;
person_spoken_with_advised_HTML?: string;
vehicles_notes_HTML?: string;
calling_card_notes_HTML?: string;
neighbours_notes_HTML?: string;
postal_mail_notes_HTML?: string;
phone_call_notes_HTML?: string;
attempts_notes_HTML?: string;
property_forsale_or_lease_sign_details_HTML?: string;
property_mail_details_HTML?: string;
property_vehicles_sighted_details_HTML?: string;
property_pets_details_HTML?: string;
property_occupancy_details_HTML?: string;
property_condition_HTML?: string;
property_type_details_HTML?: string;
property_occupied_details_HTML?: string;
email_contents_HTML?: string;
service_under_order_HTML?: string;
/*
subject_service_id
subject_id
job_id
subject_service_method_id
fellow_occupants_name
fellow_occupants_relationship
fellow_occupants_sex
authorised_employee_name
authorised_employee_job_title
authorised_employee_sex
office_business_name
exact_service_method
created_by
created_date
date_service
time_service
who_service
*/
person_spoken_with_advised_HTML_example?;
subject_model?;
job_model?;
time_service_24hr?; // new actual service time without timezone and dates

subject_service_resolution_outcome_id?;
subject_service_resolution_outcome_type_answer_array?;

  }

